import React from 'react';

import Placeholder from '../../Placeholder/Placeholder.jsx';
import SquareBox from '../../Placeholder/SquareBox.jsx';

export default () => (
  <Placeholder>
    <div className="grid">
      <div className="grid-item one-third">
        <SquareBox width="100%" height="296px" padding="0 24px 0 0" />
      </div>
      <div className="grid-item two-thirds">
        <SquareBox width="30px" height="30px" margin="0 0 8px" />
        <SquareBox width="90%" height="86px" margin="0 0 24px" />
        <SquareBox width="100%" height="149px" />
      </div>
    </div>
  </Placeholder>
);
